<app-resource-details-info
    [resource]="resource"
    [user]="user"
    [customer]="customer"
    [resourceItems]="resourceItems"
    [resourceCategories$]="resourceCategories$"
    [resourceTags$]="resourceTags$"
    [resourceType]="ResourceTypes.parentType(resource.type_id)"
    [resourceNotAvailableLabel]="resource.prompt_error"
    [resourceActionBtn]="resource.playableResource$ | async"
    resourceLabel="SCORM"
    i18n-resourceLabel
>
    <ng-container itemsHeader>
        <h3 class="sec-res-title">
            <mat-icon class="font-r-5">business_center</mat-icon>
            <span>{{ resource.title }}</span>
        </h3>
    </ng-container>
    <span managerLabel i18n="@@author">Author</span>
    <ng-container resourceItemsSection>
        <div (click)="onItemClick(item)" class="res-bull mt-1" *ngFor="let item of resourceItems; let index = index">
            <span class="index">{{ index + 1 }}</span>
            <span class="res-item-name ecourse" [class.parent]="!item.sco_parent_id">{{ item.title }}</span>
        </div>
    </ng-container>
    <span actionBtnLabel i18n="@@start">Start</span>
    <span resCodeLabel i18n>SCORM code</span>
    <ng-container resourceDates></ng-container>
    <ng-container resourceCircles>
        <div class="circle-item" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px">
            <div class="icon-wrapper">
                <mat-icon>business_center</mat-icon>
            </div>
            <span>{{ resource | resourceDefaultNameDisplay : false | async }}</span>
        </div>
    </ng-container>
</app-resource-details-info>
